import { render, staticRenderFns } from "./PaidTable.vue?vue&type=template&id=67dc401a"
import script from "./PaidTable.vue?vue&type=script&lang=js"
export * from "./PaidTable.vue?vue&type=script&lang=js"
import style0 from "./PaidTable.vue?vue&type=style&index=0&id=67dc401a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports